import {Box, Skeleton} from '@customink/pigment-react';
import React from 'react';

export default function ProductCardPriceDetailsSkeleton({isMobile}) {
  return (
    <Box
      display="flex"
      data-testid="product-price-details-skeleton"
      flexDirection={isMobile ? 'column' : 'row'}
      alignItems={isMobile ? 'flex-start' : 'center'}
      justifyContent={isMobile ? 'center' : 'flex-start'}
      flexWrap="wrap"
      lineHeight={1.25}
      gap="0.125rem 0.5rem">
      <Box display="flex" alignItems="center" gap="0.25rem">
        <Skeleton variant="text" width="3rem" height="1rem" />
        <Skeleton variant="text" width="7rem" height="1rem" />
      </Box>
      <Skeleton variant="text" width="5rem" height="1rem" />
    </Box>
  );
}
